var raw = {
  'css': null,

  'exports': {
    setInnerHTML(html) {
        this.root.innerHTML = html;
    },

    onMounted(props, state) {
        this.setInnerHTML(props.html);
    },

    onUpdated(props, state) {
        this.setInnerHTML(props.html);
    }
  },

  'template': null,
  'name': 'raw-tag'
};

export default raw;
